export default __webpack_public_path__ + "static/media/FellowshipDesktopBorder.54aa6d59.svg";